import { CareerType } from '~features/company/SalaryInfo/types';

import { Nav } from '.';

export interface NavAmplitudeAttributes {
  'data-attribute-id': string;
  'data-click-type': string;
  'data-education'?: string;
  'data-career'?: string;
}

export function getAmplitudeAttrbutes(prefix: CareerType, navData: Nav[]) {
  const ATTRIBUTE_ID = 'company__salary__seeMore__details';

  if (prefix === '경력') {
    return navData.map((item) => ({
      'data-attribute-id': ATTRIBUTE_ID,
      'data-click-type': '경력 예상연봉',
      'data-career': item.label,
    }));
  }

  return navData.map((item) => ({
    'data-attribute-id': ATTRIBUTE_ID,
    'data-click-type': '신입 예상연봉',
    'data-education': item.label,
  }));
}
